import { ApiClient } from '../../../rest-api/fetsClient';

type Params = {
  courseExportGuid: string;
  versionGuid: string;
};
export const createPublishExportVersionApi = (apiClient: ApiClient) => {
  return async (params: Params): Promise<void> => {
    const response = await apiClient['/api/course-exports/publish-version'].post({ json: params });
    await response.json();
  };
};
